/* eslint-disable import/no-default-export */
import Storage from 'app/common/lib/storage';
import { createReducer } from 'app/gamma/src/util/reducers';

export interface LabelUiState {
  showText: boolean;
}

const initialState: LabelUiState = Storage.get('labelState') || {
  showText: false,
};

export default createReducer(initialState, {
  // TODO: Sync this state with classic in real-time
});
